import m from "../../geodata/es2015/yemenHigh";
window.am4geodata_yemenHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/yemenHigh.js
// module id = null
// module chunks = 